import ThreeByOneHScrollComponents from './components';
import ThreeByOneHScrollWidget, {
  ThreeByOneHScrollWidgetProps,
} from './ThreeByOneHScrollWidget';

export default ThreeByOneHScrollWidget;
export type { ThreeByOneHScrollWidgetProps };
export { ThreeByOneHScrollComponents };

export * from './constants';
export * from './components';
